<template>
    <tr class="group-row">
        <td>
            <div :class="{'text-muted': !readonly && !isPrimaryRow}">
                <ComponentField
                    :value="group.component"
                    :readonly="readonly || !isPrimaryRow"
                    @input="$emit('component-change', componentGroup, $event)"
                />
            </div>
            <div v-if="touched && componentError" class="text-danger small">
                {{ componentError }}
            </div>
        </td>
        <td>
            <MaterialField
                :value="group.materialCategory"
                :options="materialCategoryOptions"
                :display-label="materialLabel"
                :readonly="readonly"
                :is-primary-row="true"
                @input="$emit('material-change', group, $event)"
            />
            <div v-if="touched && materialError" class="text-danger small">
                {{ materialError }}
            </div>
        </td>
        <td>
            <div v-if="readonly">
                {{ materialWeightDisplay }}
            </div>
            <div v-else>
                <WeightFieldOperator
                    :value="group.materialWeight"
                    :edit-key="`${group.localKey}:material`"
                    @input="$emit('material-weight-change', group, $event)"
                    @editing="$emit('weight-editing', $event)"
                />
                <div v-if="touched && materialWeightError" class="text-danger small">
                    {{ materialWeightError }}
                </div>
                <div v-if="touched && materialWarning" class="text-warning small">
                    {{ materialWarning }}
                </div>
            </div>
        </td>
        <FmdSubstanceFieldCell
            :value="primarySubstanceOption"
            :readonly="readonly"
            :display-name="primarySubstanceName"
            :meta="primarySubstanceMeta"
            :allow-no-substance="allowNoSubstance"
            :no-substance="primarySubstance.noSubstance"
            :no-substance-label="noSubstanceLabel"
            :touched="touched"
            :error="primarySubstanceError"
            :search-fn="searchFn"
            :placeholder="substancePlaceholder"
            :start-typing-text="startTypingText"
            :no-options-text="noOptionsText"
            :request-add-text="requestAddText"
            :group="group"
            :is-substance-selected="isSubstanceSelected"
            @input="$emit('primary-substance-select', group, $event)"
            @request-add-substance="$emit('request-add-substance', group, 0, $event)"
        />
        <FmdSubstanceWeightCell
            :substance="primarySubstance"
            :substance-weight-display="primarySubstanceWeightDisplay"
            :substance-weight-error="primarySubstanceWeightError"
            :no-substance="primarySubstance.noSubstance"
            :no-substance-label="noSubstanceLabel"
            :readonly="readonly"
            :touched="touched"
            :edit-key="`${group.localKey}:${primarySubstance.rowId || 'primary'}`"
            @input="$emit('substance-weight-change', group, primarySubstance, $event)"
            @editing="$emit('weight-editing', $event)"
        />
        <td v-if="showComment"></td>
        <td>
            <template v-if="primarySubstanceListsText">
                <b-badge
                    v-for="(item, index) in primarySubstanceListsText.split(', ')"
                    :key="`list-${index}`"
                    class="ml-50"
                >
                    {{ item }}
                </b-badge>
            </template>
            <b-badge v-else>
                -
            </b-badge>
            <b-badge v-if="primarySubstanceListsExtra > 0" class="ml-50">
                +{{ primarySubstanceListsExtra }}
            </b-badge>
        </td>
        <td v-if="!readonly" class="text-center">
            <b-button size="sm" variant="danger" class="btn-icon" @click="$emit('remove', group.localKey)">
                <feather-icon icon="MinusIcon" />
            </b-button>
        </td>
    </tr>
</template>

<script>
import { BBadge, BButton } from 'bootstrap-vue'
import { FmdSubstanceFieldCell, FmdSubstanceWeightCell, MaterialField, ComponentField, WeightFieldOperator } from '@/views/product/components/product-card/fmd/common'

export default {
    name: 'FmdComponentRow',
    components: {
        BBadge,
        BButton,
        MaterialField,
        ComponentField,
        WeightFieldOperator,
        FmdSubstanceFieldCell,
        FmdSubstanceWeightCell,
    },
    props: {
        group: { type: Object, required: true },
        componentGroup: { type: Object, required: true },
        isPrimaryRow: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        touched: { type: Boolean, default: false },
        materialCategoryOptions: { type: Array, default() { return [] } },
        materialLabel: { type: String, default: '' },
        primarySubstance: { type: Object, required: true },
        primarySubstanceName: { type: String, default: '-' },
        primarySubstanceMeta: { type: String, default: '' },
        primarySubstanceOption: { type: Object, default: null },
        materialWeightDisplay: { type: String, default: '-' },
        primarySubstanceWeightDisplay: { type: String, default: '-' },
        materialError: { type: String, default: '' },
        componentError: { type: String, default: '' },
        primarySubstanceError: { type: String, default: '' },
        materialWeightError: { type: String, default: '' },
        primarySubstanceWeightError: { type: String, default: '' },
        materialWarning: { type: String, default: '' },
        showComment: { type: Boolean, default: true },
        primarySubstanceListsText: { type: String, default: '' },
        primarySubstanceListsExtra: { type: Number, default: 0 },
        allowNoSubstance: { type: Boolean, default: false },
        noSubstanceLabel: { type: String, default: '' },
        searchFn: { type: Function, required: true },
        substancePlaceholder: { type: String, default: '' },
        startTypingText: { type: String, default: '' },
        noOptionsText: { type: String, default: '' },
        requestAddText: { type: String, default: '' },
        deleteText: { type: String, default: '' },
        isSubstanceSelected: { type: Function, required: true },
    },
}
</script>
